// extracted by extract-css-chunks-webpack-plugin
module.exports = {"list":"participants-list__list--3OfCI"};